import { Component, inject } from '@angular/core';
import { environment } from '@env/environment';
import { SilentRefreshService } from '@app/services/silentRefresh/silent-refresh';
import { Loader } from '@app/components/shared/loader/loader';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth',
  imports: [Loader],
  templateUrl: './auth.html',
  styleUrl: './auth.css',
})
export class Auth {
  private readonly silentRefresh = inject(SilentRefreshService);
  private readonly router = inject(Router);

  ngOnInit() {
    this.silentRefresh.start({
      app_id: environment.appId,
      intervalMs: 10000,
      origin: new URL(environment.ssoUrl).origin,
      onSuccess: (data: any) => {
        this.router.navigate(['/home']);
      },
      onFailure: (error: any) => {
        this.router.navigate(['/login'], {
          queryParams: { reason: 'unauthenticated' },
        });
      },
    });
  }
}
